import React, { ReactNode, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useShowMoreButton } from '../../../hooks/useShowMoreButton';
import { useToggle } from '../../../hooks/useToggle';
import { ReadMoreButton, ReadMoreWrapper } from './styled';

interface ReadMoreProps {
  description: string | ReactNode;
}

export const ReadMore: React.FC<ReadMoreProps> = ({ description }) => {
  const { t } = useTranslation();
  const [visibleText, showText] = useToggle(false);
  const [targetRef, showButton] = useShowMoreButton();

  const handleShowText = useCallback(() => showText(), [showText]);

  return (
    <>
      <ReadMoreWrapper
        $isPruned={!visibleText}
        ref={targetRef}
        id="read-more"
        data-cy="read-more"
      >
        {description}
      </ReadMoreWrapper>
      {showButton && !visibleText && (
        <ReadMoreButton
          tag="body_1"
          onClick={handleShowText}
          onKeyPress={() => {}}
          tabIndex={0}
          role="button"
          data-cy="read-more-button"
        >
          {t('common.read_more')}
        </ReadMoreButton>
      )}
    </>
  );
};
